"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultApprovalState = void 0;
exports.defaultApprovalState = {
    approvals: {},
    transactionId: "",
    status: "pending",
    showApprovalModal: false,
    isCheckingApproval: false,
    isApproved: false,
    isApproving: false,
};
//# sourceMappingURL=WalletApproveInterface.js.map